export const ACTION_SAVE_CREDIT_OFFERS_PAGINATED = 'ACTION_SAVE_CREDIT_OFFERS_PAGINATED';
export const ACTION_UPLOAD_CREDIT_DOCUMENT = 'ACTION_UPLOAD_CREDIT_DOCUMENT'
export const ACTION_GET_SIMULATIONS = 'ACTION_GET_SIMULATIONS';
export const ACTION_EXPORT_CSV = 'ACTION_EXPORT_CSV';